export const name = "PARSE_JSON";
export const summary = `Converts a JSON-formatted \`STRING\` value to a \`JSON\` value.`;
export const reference = `
## PARSE_JSON

Converts a JSON-formatted \`STRING\` value to a \`JSON\` value.

\`\`\`
PARSE_JSON(
  json_string_expr
  [, wide_number_mode => { 'exact' | 'round' }]
)
\`\`\`

### Description

Converts a JSON-formatted \`STRING\` value to a \`JSON\` value.

Arguments:

- \`json_string_expr\`: A JSON-formatted string. For example:

- \`wide_number_mode\`: A named argument with a \`STRING\` value. Determines how to handle numbers that can't be stored in a \`JSON\` value without the loss of precision. If used, \`wide_number_mode\` must include one of the following values:

Numbers from the following domains can be stored in JSON without loss of precision:

- 64-bit signed/unsigned integers, such as \`INT64\`
- \`FLOAT64\`


### Return type

\`JSON\`


### Examples

In the following example, a JSON-formatted string is converted to \`JSON\`.



\`\`\`
SELECT PARSE_JSON('{"coordinates": [10, 20], "id": 1}') AS json_data;

/*--------------------------------*
 | json_data |
 +--------------------------------+
 | {"coordinates":[10,20],"id":1} |
 *--------------------------------*/
\`\`\`

The following queries fail because:

- The number that was passed in can't be stored without loss of precision.
- \`wide_number_mode=>'exact'\` is used implicitly in the first query and explicitly in the second query.



\`\`\`
SELECT PARSE_JSON('{"id": 922337203685477580701}') AS json_data; -- fails
SELECT PARSE_JSON('{"id": 922337203685477580701}', wide_number_mode=>'exact') AS json_data; -- fails
\`\`\`

The following query rounds the number to a number that can be stored in JSON.



\`\`\`
SELECT PARSE_JSON('{"id": 922337203685477580701}', wide_number_mode=>'round') AS json_data;

/*------------------------------*
 | json_data |
 +------------------------------+
 | {"id":9.223372036854776e+20} |
 *------------------------------*/
\`\`\`

You can also use valid JSON-formatted strings that don't represent name/value pairs. For example:



\`\`\`
SELECT PARSE_JSON('6') AS json_data;

/*------------------------------*
 | json_data |
 +------------------------------+
 | 6 |
 *------------------------------*/
\`\`\`



\`\`\`
SELECT PARSE_JSON('"red"') AS json_data;

/*------------------------------*
 | json_data |
 +------------------------------+
 | "red" |
 *------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
